import loadGoogleMapsApi from 'load-google-maps-api'

export const maps = (): Promise<typeof maps>=>
  loadGoogleMapsApi({
    key: window.GOOGLE_MAPS_KEY,
    libraries: ['places'],
    language: window.language,
  })
